export default {
  error_messages: {
    failed_to_fetch_orders:
      'Nu s-au putut încărca datele. Faceți clic pe pictograma „reîmprospătare" sau încercați din nou în 1 minut.',
    something_went_wrong: 'Ceva a mers greșit, vă rugăm să încercați din nou.',
  },
};
